import { Badge } from '@sea-snag/ui';
import { ArrowDown, ArrowUp, Minus } from 'lucide-react';

interface PriceChangeBadgeProps {
  currentPrice: number;
  suggestedPrice: number;
  className?: string;
}

export function PriceChangeBadge({
  currentPrice,
  suggestedPrice,
  className,
}: PriceChangeBadgeProps) {
  const changePct = currentPrice > 0 ? ((suggestedPrice - currentPrice) / currentPrice) * 100 : 0;
  const absChange = Math.abs(changePct);

  if (absChange < 0.5) {
    return (
      <Badge variant="secondary" className={className}>
        <Minus className="size-3" />
        0.0%
      </Badge>
    );
  }

  if (changePct < 0) {
    return (
      <Badge
        variant="secondary"
        className={`bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 ${className ?? ''}`}
      >
        <ArrowDown className="size-3" />
        {absChange.toFixed(1)}%
      </Badge>
    );
  }

  return (
    <Badge
      variant="secondary"
      className={`bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 ${className ?? ''}`}
    >
      <ArrowUp className="size-3" />
      {absChange.toFixed(1)}%
    </Badge>
  );
}
